// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-view .page-header{font-size:25px;margin-bottom:30px}.login-view .page-sub-header{text-transform:none;font-size:15px;margin-top:10px;color:#888}.login-view .button-container{margin-top:50px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
